import { render, staticRenderFns } from "./TrafficRequestDropdownRecommendations.vue?vue&type=template&id=277e9290&scoped=true"
import script from "./TrafficRequestDropdownRecommendations.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestDropdownRecommendations.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestDropdownRecommendations.vue?vue&type=style&index=0&id=277e9290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e9290",
  null
  
)

export default component.exports